import { useState, useEffect } from "react"
import CoordinateModule from "../Modules/CoordinateModule"

export default function ImageProperties( props )
{
    const layers = props.layers 
    const setLayers = props.setLayers 
    const layersCfg = props.layersCfg
    const selected = props.selected 
    const selectedIdx = props.selectedIdx
    const modalOpen = props.modalOpen
    const accountType = props.accountType

    const selectedCoords = props.selectedCoords
    const setSelectedCoords = props.setSelectedCoords
    const setManualSelectedCoords = props.setManualSelectedCoords

    const [ name, setName ] = useState(null)

    const reload = () => {
        if( selectedIdx < 0 )
        {
            return;
        }

        if( !layersCfg.current[selected] )
        {
            return
        }

        let properties = layersCfg.current[selected].properties
        let n = layersCfg.current[selected].name 
        setName( (n) ? n : "" )

        if( properties == null )
        {
            properties = {}
        }
    }

    useEffect( () => {
        reload()
    }, [] )

    useEffect( () => {
        reload()
    },[selected])

    useEffect( () => {
        if( name == null )
        {
            return
        }

        layersCfg.current[selected].name = name 
        setLayers([...layers]) 
    },[ name ])

    return (
        <>
            <CoordinateModule coordinates={selectedCoords} 
                              setCoordinates={setSelectedCoords}
                              selected={selected}
                              setManual={setManualSelectedCoords}
            />
        </>
    )
}
